import {
  PROMISE_MIDDLEWARE_ERROR,
  DEQUEUE_ERROR,
  QUEUE_ERROR
} from '../constants/ActionTypes';
import { resolve } from '../lib/parser';
const defaultStore = {
  errorQueue: [] // contains an array of the error messages
};

/**
 * This reducer handle errors.
 * When ever the app need to display an error msg. It dispatches an action with following structure:
 *
 * { type: QUEUE_ERROR, payload : { message : "error" } }
 *
 * The Promise middleware errors are also handled here, for async actions.
 *       For example: AUTHENTICATION_REJECTED. This actions caught by this reducer and queues the error.
 *
 */

const error = (state = defaultStore, action) => {
  let type = action.type;
  let errorQueue = state.errorQueue;
  const rejectedRegExp = new RegExp('[A-Za-z]*_REJECTED');
  if (rejectedRegExp.exec(type)) {
    // checks if error comes from promise_middleware.
    type = PROMISE_MIDDLEWARE_ERROR;
  }

  switch (type) {
    case QUEUE_ERROR:
    case PROMISE_MIDDLEWARE_ERROR:
      let errorMessage = action.payload.message;
      if (!!resolve(action.payload.response)('data')('result')('message')()) {
        errorMessage = action.payload.response.data.result.message;
      }

      if (errorMessage == '') {
        errorMessage = 'Oops, there has been a problem!';
      }

      if (typeof errorQueue !== 'undefined' && errorQueue.length > 0) {
        return { ...state, errorQueue: [errorMessage, ...state.errorQueue] };
      } else {
        return { ...state, errorQueue: [errorMessage] };
      }

    case DEQUEUE_ERROR:
      if (typeof errorQueue !== 'undefined' && errorQueue.length > 0) {
        errorQueue = errorQueue.slice(0, errorQueue.length - 1);
      }
      return { ...state, errorQueue: errorQueue };

    default:
      return state;
  }
};

module.exports = error;



// WEBPACK FOOTER //
// ./reducers/errorReducers.js